<template>
    <div id="file-upload-catalog-component">
        <div id="mainContent">
            <form id="formImport" class="formImport">
                <input type="hidden" name="company_id" value="6">
                <div class="row justify-content-center scr-gap-15-0">
                    <div class="col-12 col-md-4">
                        <div class="fotoUploader">
                            <span class="btn btn-file">
                                Archivo de siniestro <br> <i class="fas fa-upload"></i>
                                <input type="file"
                                       data-label="avatar"
                                       name="xlsFile"
                                       v-on:change="getFile"
                                       placeholder="avatar">
                            </span>
                            <span class="label-file-papeleria alert alert-info file"></span>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <button id="dyn-button" type="button" class="btn btn-primary" v-on:click="guardar()">
                            Cargar
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {importsinesterfileService} from "../../Services/ImportSinesterFile.service";
import {rolesService} from "../../Services/Roles.service";
import {getFormData} from "../../Utils/getDataForm";

export default {
    name: "load-sinester-file",
    mixins: [myMixins],
    data() {
        return {
            roles: [],
            providers: [],
        }
    },
    methods: {

        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formImport');
            const formData = getFormData('formImport');
            if (respVal) {
                this.disableSubmitBtn(true);
                resp = await importsinesterfileService.saveOne(formData, {isForm: true});
                this.disableSubmitBtn(false);
            }
            this.modificar = false;
            this.getAlert(resp.process);
        },

        async index() {
            this.roles = await rolesService.getProvidersForSinester();
        },

        getFile(event) {
            this.getNameFile(event, 'file');
        },

    },
    mounted() {
        this.index();
    }
}
</script>

<style scoped>
.fotoUploader {
    margin-top: 0
}
</style>
